type Metadata = {
    icon: string;
    displayAs: string;
    class: string;
};

const packageTypeMetadata: Record<string, Metadata> = {
    'Unknown': {
        'icon': 'help-circle-outline',
        'displayAs': 'UNKNOWN',
        'class': 'shipping-color-failure'
    },
    'LibraryDefinitionsPackage': {
        'icon': 'alpha-l-box-outline',
        'displayAs': 'Library definitions',
        'class': ''
    },
    'LibraryContentPackage': {
        'icon': 'list-box-outline',
        'displayAs': 'Library content',
        'class': ''
    }
};

const packageStatusMetadata: Record<string, Metadata> = {
    'Unknown': {
        'icon': 'help-circle-outline',
        'displayAs': 'UNKNOWN',
        'class': 'shipping-color-failure'
    },
    'ReadyForAssembly': {
        'icon': 'progress-clock',
        'displayAs': 'Ready for assembly',
        'class': ''
    },
    'AssemblyInProgress': {
        'icon': 'progress-clock',
        'displayAs': 'Assembly in progress',
        'class': ''
    },
    'ReadyForDownload': {
        'icon': 'check-circle',
        'displayAs': 'Ready for download',
        'class': 'shipping-color-ok'
    },
    'Uploaded': {
        'icon': 'magnify',
        'displayAs': 'Uploaded',
        'class': ''
    },
    'AnalyzisInProgress': {
        'icon': 'progress-clock',
        'displayAs': 'Analyzis in progress',
        'class': ''
    },
    'ReadyForImport': {
        'icon': 'magnify',
        'displayAs': 'Ready for import',
        'class': ''
    },
    'ImportInProcess': {
        'icon': 'progress-clock',
        'displayAs': 'Import in progress',
        'class': ''
    },
    'ImportDone': {
        'icon': 'check-circle',
        'displayAs': 'Imported',
        'class': 'shipping-color-ok'
    },
    'AssemblyFailed': {
        'icon': 'alert-circle',
        'displayAs': 'Assembly failed',
        'class': 'shipping-color-failure'
    },
    'AnalyzisFailed': {
        'icon': 'alert-circle',
        'displayAs': 'Analyzis failed',
        'class': 'shipping-color-failure'
    },
    'ImportFailed': {
        'icon': 'alert-circle',
        'displayAs': 'Import failed',
        'class': 'shipping-color-failure'
    },
    'NoChanges': {
        'icon': 'circle-outline',
        'displayAs': 'No changes detected',
        'class': ''
    }
};

export const packageMetadata = {
    type: {
        icon: (t: string) => packageTypeMetadata[t].icon,
        displayAs: (t: string) => packageTypeMetadata[t].displayAs,
        class: (t: string) => packageTypeMetadata[t].class
    },
    status: {
        icon: (s: string) => packageStatusMetadata[s].icon,
        displayAs: (s: string) => packageStatusMetadata[s].displayAs,
        class: (s: string) => packageStatusMetadata[s].class
    }
};

// Must match the statuses accepted by ShippingPackageRepository.UpdatePackageExtraction
const editableStatuses = ['ReadyForDownload', 'AssemblyFailed'];

export function isPackageEditable(shippingPackage: { status: string } | null): boolean {
    return !!shippingPackage && editableStatuses.includes(shippingPackage.status);
}
